var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiModel } from "./api-model";
import { Value } from "./value";
import * as moment from "moment";
var ProgramArticle = /** @class */ (function (_super) {
    __extends(ProgramArticle, _super);
    function ProgramArticle(data) {
        var _this = this;
        data.startDate = moment(data.startDate).toDate();
        data.endDate = moment(data.endDate).toDate();
        data.broadcastDate = moment(data.broadcastDate).toDate();
        data.lastUpdate = moment(data.lastUpdate);
        _this = _super.call(this, data) || this;
        var valueKeys = [
            "broadcasting",
            "category",
            "channel",
            "city",
            "competition",
            "country",
            "leg",
            "match",
            "sport",
            "type",
            "event",
        ];
        valueKeys.forEach(function (key) {
            if (_this[key]) {
                _this[key] = new Value(_this[key]);
            }
            else {
                _this[key] = new Value({ id: null, value: null });
            }
        });
        _this.active = false;
        _this.pictureModified = false;
        _this.elementList = _this.sport.value
            ? _this.sport.value
            : _this.type.value
                ? _this.type.value
                : "";
        return _this;
    }
    ProgramArticle.prototype.getTitle = function (destination) {
        this.title = this.elementList;
        if (destination) {
            if (this.destinations.find(function (t) { return t.id == destination.value; })) {
                var translation = this.destinations
                    .find(function (t) { return t.id == destination.value; })
                    .value.translations.find(function (t) { return t.name == "Title"; });
                if (translation && translation.content) {
                    this.title = translation.content;
                }
            }
        }
        return this.title;
    };
    ProgramArticle.prototype.getCommentatorShort = function () {
        if (!this.commentator) {
            return "";
        }
        var commentators = this.commentator.split("|");
        if (commentators.length === 0) {
            return "";
        }
        else if (commentators.length > 2) {
            return commentators[0] + "|" + commentators[1] + "...";
        }
        else {
            return this.commentator;
        }
    };
    ProgramArticle.prototype.hasBeenUpdatedRecently = function () {
        return this.getHoursDiff() < 24;
    };
    ProgramArticle.prototype.getHoursDiff = function () {
        var currentTime = moment();
        var timeStore = moment(this.updateDate);
        return currentTime.diff(timeStore, "h");
    };
    ProgramArticle.prototype.HasLastUpdate = function () {
        return this.updateDate.toString() !== "0001-01-01T00:00:00";
    };
    ProgramArticle.prototype.GetUpdateDateCleaned = function () {
        return moment(this.updateDate).format("DD/MM/YYYY HH:mm:ss");
    };
    ProgramArticle.prototype.getMultiCamType = function () {
        return this.isMain ? "Main" : "Sub";
    };
    ProgramArticle.prototype.isSpevInMultiCamRelations = function (spevId) {
        var result = false;
        if (this.isMultiCam) {
            if (this.multiCamRelations.find(function (mci) { return mci.mainSpevId === spevId; })) {
                result = true;
            }
            else {
                this.multiCamRelations.forEach(function (multiCamInfo) {
                    if (multiCamInfo.subSpevIds.find(function (ssi) { return ssi === spevId; })) {
                        result = true;
                    }
                });
            }
        }
        return result;
    };
    ProgramArticle.prototype.isCurrent = function () {
        var currentTime = moment();
        return currentTime.isBetween(moment(this.startDate), moment(this.endDate));
    };
    ProgramArticle.prototype.getTranslationsByType = function (type) {
        return this.translations.find(function (translation) { return translation.id === type; });
    };
    /**
     * Remove picture raw data to avoid heavy request
     */
    ProgramArticle.prototype.cleanPicture = function (blob) {
        if (this.translations && this.translations.length > 0) {
            this.translations = this.translations.map(function (t) {
                if (t.value["picture"]) {
                    var formats = [
                        "original",
                        "format_16_9",
                        "format_4_3",
                        "format_3_4",
                    ];
                    formats.forEach(function (format) {
                        if (t.value.picture[format]) {
                            t.value.picture[format].displayUrl = null;
                            if (blob && t.value.picture[format].blob) {
                                t.value.picture[format].blob = null;
                            }
                        }
                    });
                }
                return t;
            });
        }
    };
    ProgramArticle.prototype.assignNewPictures = function (translations) {
        var _this = this;
        translations.forEach(function (translation) {
            _this.translations
                .filter(function (t) { return t.id === translation.id; })
                .map(function (t) {
                if (t.value.picture && t.value.picture.duplicatedFromLanguage) {
                    var formats = [
                        "original",
                        "format_16_9",
                        "format_4_3",
                        "format_3_4",
                    ];
                    formats.forEach(function (format) {
                        if (t.value.picture[format]) {
                            t.value.picture[format] = translation.value.picture[format];
                        }
                    });
                }
            });
        });
    };
    return ProgramArticle;
}(ApiModel));
export { ProgramArticle };
var MultiCamRelation = /** @class */ (function (_super) {
    __extends(MultiCamRelation, _super);
    function MultiCamRelation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MultiCamRelation;
}(ApiModel));
export { MultiCamRelation };



// WEBPACK FOOTER //
// ./src/app/models/program-article.ts.pre-build-optimizer.js